import { createSelector } from '@reduxjs/toolkit';

export const selectShowCasePreview = createSelector(
  ({ showcasePreview }) => showcasePreview,
  (state) => state,
);
